<template>
  <div class="h-15 -mt-4 relative">
    <div class="absolute right-14 p-2 px-4 bg-hahn-dark-100 min-w-16 my-2 h-11 group z-10">
      {{ $keycloak?.idTokenParsed?.preferred_username ? $keycloak?.idTokenParsed?.preferred_username : 'Unknown User' }} ⮟
      <div class="-ml-4 -mr-4 border-l-1 hidden py-2 group-hover:block mt-2 bg-hahn-dark-100 hover:bg-hahn-dark-200 cursor-pointer" @click="$keycloak.logout">
        Logout
      </div>
    </div>
  </div>
  <div>

  </div>
</template>

<script>
export default {
  name: 'ProfileDropdown',
}
</script>